import { render, staticRenderFns } from "./ImportSidebar.vue?vue&type=template&id=706dad26&"
import script from "./ImportSidebar.vue?vue&type=script&lang=js&"
export * from "./ImportSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports